import React, { useContext } from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import './App.css';

import { UserContext } from './context/UserProvider';

import Login from './components/Login';
import AdminView from './components/Admin/AdminView';
import UserView from './components/User/UserView';


import WorkersForm from './components/Admin/WorkersForm';
import Config from './components/Admin/Config';
import Home from './components/Map/Home';
import Profile from './components/User/Profile';
import FormRegister from './components/FormRegister';
import Info from './components/Info';
import AllWorkers from './components/Admin/AllWorkers';
import WorketView from './components/Worker/WorkerView';
import WorkerProfile from './components/Worker/WorkerProfile';


function App() {

  const { user } = useContext(UserContext);



  return (

    <BrowserRouter>
      <Switch>
        <Route path='/login'>
          <Login />
        </Route>
        <Route path='/info'>
          <Info />
        </Route>
        <Route path='/emailForm'>
          <FormRegister />
        </Route>
        <Route path='/register'>
          <FormRegister />
        </Route>
        <Route exact path='/dashboard'>
          {
            user.role === 'admin' && <AdminView />
          }
          {
            user.role === 'usuario' && <UserView />
          }
          {
            user.role === 'trabajador' && <WorketView />
          }
        </Route>
        <Route path='/dashboard/addWorker'>
          {
            user.role === 'admin' && <WorkersForm />
          }

        </Route>

        <Route path='/dashbord/worker'>
          <WorkerProfile />
        </Route>

        <Route path='/dashboard/all'>
          <AllWorkers />
        </Route>

        <Route exact path='/dashboard/config'>
          <Config />
        </Route>
        <Route path='/map'>
          <Home />
        </Route>
        <Route exact path='/dashbord/profile'>
          <Profile />
        </Route>
        {/*         <Route exact path='/' component= { Login }/>  
        <Route path='/info' component= { Info }/>
        <Route path='/register' component= { FormRegister }/>
        <Route path='/auto' component= { Car }/>
        <Route path='/pay' component= { Card }/> */}
      </Switch>
    </BrowserRouter>
  );
}

export default App;